<div class="main">
  @if (selectedSubscription !== null) {
  <div class="subscriptions-breadcrumb">
    <f-breadcrumb divider=">" [breadcrumbItems]="items" (breadcrumbSelected)="onBreadcrumbSelected($event)">
    </f-breadcrumb>
  </div>

  <h1>{{ selectedSubscription.subscriptionName || selectedSubscription.title }}</h1>
  @if (selectedSubscription.title) {
    <div>
      <span class="subscription-title-label">Title: {{ selectedSubscription.title }}</span>
    </div>
  }

  <p class="subscriptions-version-label">{{reports.length}} items</p>

  <div class="subscriptions-version-table">
    <f-table auto-sort>
      <table role="table" aria-colcount="7">
        <caption class="screen-reader-text">
          This is a table containing all versions of the selected subscription.
        </caption>
        <thead>
          <tr role="row">
            <th data-type="string" class="text-align-left w-15" role="columnheader">
              Version Name
            </th>
            <th data-type="string" data-sortable class="text-align-left" role="columnheader">
              Creation Time [US Central]
            </th>
            <th data-type="string" data-sortable class="text-align-left" role="columnheader">
              Download
            </th>
          </tr>
        </thead>
        <tbody>
          @for (report of reports; track report) {
          <tr role="row">
            <td role="cell" class="text-wrap-nowrap">
              {{report.version}}
            </td>
            <td role="cell" class="text-align-left">
              {{ formatTimestamp(report.endDttm) }}
            </td>
            <td role="cell" class="text-align-left">
              @if (isReportFailed(report)) {
                <f-alert variant="error">
                  {{ report.displayMessage }}
                </f-alert>
              } @else {
                <a (click)="onDownloadClick(report.storageURL)">Download</a>
              }
            </td>
          </tr>
          }
        </tbody>
      </table>
    </f-table>
  </div>
  }
</div>